import React, { FC } from 'react'
import { IFilterMultiSelectOption } from 'transfix-ui/components/FilterMultiSelect'
import {
  ICarrierCallListMatchStrategyEnum,
  ILaneCarrierMatchListFilterEnum,
} from 'types/graphqlTypes'
import {
  FilterMultiSelectDisplay,
  IFilterMultiSelectDisplayProps,
} from 'apps/marketplace/components'
import { StarIcon } from 'transfix-icons'
import { getMatchEnum } from '../utils'

const matchTypesOptions: IFilterMultiSelectOption[] = [
  {
    label: 'Lane Alert',
    value: ICarrierCallListMatchStrategyEnum.lane_alert,
    selected: false,
  },
  {
    label: 'Ran Before',
    value: ICarrierCallListMatchStrategyEnum.ran_before,
    selected: false,
  },
  {
    label: 'Ran Backhaul',
    value: ICarrierCallListMatchStrategyEnum.ran_backhaul,
    selected: false,
  },
  {
    label: 'Ran Headhaul',
    value: ICarrierCallListMatchStrategyEnum.ran_headhaul,
    selected: false,
  },
  {
    label: 'Reload',
    value: ICarrierCallListMatchStrategyEnum.reload,
    selected: false,
  },
  {
    label: 'Reserved Load',
    value: ICarrierCallListMatchStrategyEnum.reserved_loads,
    selected: false,
  },
]

const getSelectedOptions = (
  selectedValues: IFilterMultiSelectOption['value'][]
): IFilterMultiSelectOption[] => {
  if (!selectedValues || selectedValues.length < 1) {
    return matchTypesOptions
  }

  return matchTypesOptions.map(option => ({
    ...option,
    selected: [...selectedValues].includes(option.value),
  }))
}

// Props are omitted because they're explicitly set in child component
type TOmittedProp = 'options' | 'icon' | 'id' | 'label' | 'dataTest' | 'onSelectHandler'

export interface IFilterInputMatchTypeProps
  extends Omit<IFilterMultiSelectDisplayProps, TOmittedProp> {
  value: (ICarrierCallListMatchStrategyEnum | ILaneCarrierMatchListFilterEnum)[]
  onSelectMatchTypes: (selected: ICarrierCallListMatchStrategyEnum[]) => void
}

export const FilterInputMatchType: FC<IFilterInputMatchTypeProps> = ({
  onSelectMatchTypes,
  value: initialValue,
  ...rest
}) => {
  const options = getSelectedOptions(initialValue)

  const selectHandler = (selected?: string[]) => {
    const selectedEnums = selected?.map(type => getMatchEnum(type))
    onSelectMatchTypes(selectedEnums || [])
  }

  return (
    <FilterMultiSelectDisplay
      icon={<StarIcon size='large' />}
      dataTest='filter-match-type'
      id='filter-match-type'
      label='Match Type'
      onSelectHandler={selectHandler}
      options={options}
      {...rest}
    />
  )
}
